var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unload-content-wrapper"},[_c('unload-content-info',{attrs:{"cargo":_vm.cargo}}),_c('unload-content-cargo',{attrs:{"vehicles-list":_vm.vehiclesList,"cargo":_vm.cargo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }